import { HasKind } from '@/utilities/HasKind';

export const kind = 'StartTask';

export type StartTask = HasKind<typeof kind>;

export const startTask: StartTask = { kind };
